export default __webpack_public_path__ + "static/media/uploader-roche-1.b995552d.png";